import { IAppState } from 'shared/common/state';

export function botCathcerLinksSelector({ seoBotCatcherLinks }: IAppState) {
  return seoBotCatcherLinks;
}
